<template>
    <div class="col-12">
        <div class="form-group">
            <label>Select Group Name</label>
            <div class="position-relative">
                <input
                    type="text"
                    v-model="selectedGroupName"
                    class="form-control"
                    placeholder="Enter or select a group name"
                    @focus="openDropdown('group')"
                    @input="filterGroups"
                    @keyup.enter="closeDropdown('group')"
                    ref="groupDropdown"
                />
                <ul class="dropdown-menu w-100 show dropdown-scroll" v-show="showGroupDropdown" ref="groupMenu">
                    <li v-if="filteredGroups.length === 0" class="dropdown-item text-muted">
                        No groups found
                    </li>
                    <li v-for="(group, index) in filteredGroups" :key="index">
                        <a class="dropdown-item" @click="selectGroup(group)">
                            {{ group.group_name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="form-group">
            <label>Select Batch Name <small>(showing only {{ accountType }} Batch Type)</small></label>
            <div class="position-relative">
                <input
                    type="text"
                    v-model="selectedBatchName"
                    class="form-control"
                    placeholder="Enter or select a batch name"
                    @focus="openDropdown('batch')"
                    @input="filterBatches"
                    @keyup.enter="closeDropdown('batch')"
                    ref="batchDropdown"
                    :disabled="!selectedGroupId"
                />
                <ul class="dropdown-menu w-100 show dropdown-scroll" v-show="showBatchDropdown" ref="batchMenu">
                    <li v-if="filteredBatches.length === 0" class="dropdown-item text-muted">
                        No {{ accountType }} batch types found
                    </li>
                    <li v-for="(batch, index) in filteredBatches" :key="index">
                        <a class="dropdown-item" @click="selectBatch(batch)">
                            {{ batch.batch_name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "SelectBatch",
    props: {
        errors: Object,
        accountType: String,
        value: Object
    },

    data() {
        return {
            selectedGroupId: null,
            selectedGroupName: "",
            selectedBatchId: this.value || null,
            selectedBatchName: "",
            showGroupDropdown: false,
            showBatchDropdown: false,
            groups: [],
            filteredGroups: [],
            batches: [],
            filteredBatches: []
        };
    },

    mounted() {
        this.fetchGroups();
        document.addEventListener("click", this.handleClickOutside);
    },

    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },

    watch: {
        accountType(newVal) {
            if (newVal) {
                this.fetchGroups();
            }
        }
    },

    methods: {

        openDropdown(type) {
            if (type === "group") {
                this.showGroupDropdown = true;
                this.fetchGroups();
            } else if (type === "batch") {
                this.showBatchDropdown = true;
                this.fetchBatches();
            }
        },

        closeDropdown(type) {
            setTimeout(() => {
                if (type === "group") this.showGroupDropdown = false;
                if (type === "batch") this.showBatchDropdown = false;
            }, 200);
        },

        handleClickOutside(event) {
            if (
                this.$refs.groupDropdown &&
                !this.$refs.groupDropdown.contains(event.target) &&
                this.$refs.groupMenu &&
                !this.$refs.groupMenu.contains(event.target)
            ) {
                this.showGroupDropdown = false;
            }

            if (
                this.$refs.batchDropdown &&
                !this.$refs.batchDropdown.contains(event.target) &&
                this.$refs.batchMenu &&
                !this.$refs.batchMenu.contains(event.target)
            ) {
                this.showBatchDropdown = false;
            }
        },

        fetchGroups() {
            axios.get("/business/business-stored-accounts/groups/list")
                .then(response => {
                    this.groups = response.data.body.list.data;
                    this.filteredGroups = [...this.groups];
                })
                .catch(error => {
                    this.$toast.error("Error fetching groups. Please try again.", {
                        timeout: 3000
                    });
                });
        },

        fetchBatches() {
            if (!this.selectedGroupId || !this.accountType) return;

            axios.get(`/business/business-stored-accounts/groups/${this.selectedGroupId}/${this.accountType}/batches/list`)
                .then(response => {
                    this.batches = response.data.body.list.data;
                    this.filteredBatches = [...this.batches];
                })
                .catch(error => {
                    this.$toast.error("Error fetching batches. Please try again.", {
                        timeout: 3000
                    });
                });
        },

        filterGroups() {
            const searchTerm = this.selectedGroupName.toLowerCase();
            this.filteredGroups = this.groups.filter(group =>
                group.group_name.toLowerCase().includes(searchTerm)
            );
        },

        filterBatches() {
            const searchTerm = this.selectedBatchName.toLowerCase();
            this.filteredBatches = this.batches.filter(batch =>
                batch.batch_name.toLowerCase().includes(searchTerm)
            );
        },

        selectGroup(group) {
            this.selectedGroupId = group.id;
            this.selectedGroupName = group.group_name;
            this.showGroupDropdown = false;
            this.selectedBatchId = null;
            this.selectedBatchName = "";
            this.fetchBatches();
            this.$emit("update:groupId", this.selectedGroupId);
        },

        selectBatch(batch) {
            this.selectedBatchId = batch.id;
            this.selectedBatchName = batch.batch_name;
            this.showBatchDropdown = false;
            this.$emit("input", batch);
        }
    }
};
</script>

<style scoped>
.dropdown-scroll {
    max-height: 200px;
    overflow-y: auto;
}
</style>
